import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Tooltipコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/tooltip?version=react" target="_blank">こちら</a>
 */
export const Tooltip = ({ ...props }) => {
    return <View {...props} />
}

Tooltip.propTypes = {
    /**
     * Tooltipに表示するコンテンツ
     */
    content: PropTypes.node,
    /**
     * Tooltip表示のトリガー
     */
    trigger: PropTypes.oneOf(['hover', 'click']),
    /**
     * Tooltipの表示位置
     */
    position: PropTypes.oneOf([
        'top',
        'top-left',
        'top-right',
        'right',
        'right-top',
        'right-bottom',
        'bottom',
        'bottom-left',
        'bottom-right',
        'left',
        'left-top',
        'left-bottom'
    ]),
    /**
     * triggerが`hover`時、Tooltipにカーソルを合わせても非表示
     */
    hideTooltipOnBlur: PropTypes.bool,
    /**
     * 背景を黒に変更
     */
    isDark: PropTypes.bool,
    /**
     * Tooltip表示イベント発火の対象要素
     */
    children: PropTypes.node,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Tooltip.defaultProps = {
    trigger: 'hover',
    position: 'right',
    hideTooltipOnBlur: false,
    isDark: false
}
